import { Card } from "reactstrap";
import { PrivateMessage } from "../types/PrivateChat";
import { useAuth } from "../../../../context/AuthContext";

interface Props {

    message: PrivateMessage;
}

const PrivateMessageBubble = ({
    message
}: Props) => {
const { userID } = useAuth();

const isMine = message.senderId === userID;
    return (

        <div
    className={`d-flex mb-2 ${
        isMine ? "justify-content-end" : "justify-content-start"
    }`}
>
    <Card
        className="p-2"
        style={{
            maxWidth: "75%",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            borderRadius: "12px"
        }}
    >
        <div>{message.message}</div>

        <div className="small text-end mt-1 text-muted">
            {new Date(message.sentAt).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit"
            })}
        </div>
    </Card>
</div>

    );
};

export default PrivateMessageBubble;